import {Line} from 'vue-chartjs'

export default {
    name: 'component__line-chart-fff',
    extends: Line,
    props: {
        rawData: {
            type: Array,
            default: []
        }

    },
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: true,
                    mode: 'label',
                    intersect: false
                },
                legend: {
                    display: false,
                    labels: {
                        fontColor: '#687485'
                    }
                },
                scales: {
                    xAxes: [
                        {
                            display: false,
                            gridLines: {
                                display: false
                            }
                        }
                    ],
                    yAxes: [
                        {
                            display: false
                        }
                    ]
                },
                hover: {
                    mode: 'nearest',
                    intersect: false,
                    axis: 'xy'
                }

            }
        }
    },
    mounted() {
        let chartData = {
            labels: ['', '', '', '', '', '', '', '', '', '', '', ''],
            datasets: [
                {
                    label: '',
                    data: this.rawData,
                    point: '0',
                    type: 'line',
                    pointBorderWith: 0,
                    borderColor: 'yellowgreen',
                    pointHoverBorderColor: 'transparent',
                    pointHoverBorderWidth: 0,
                    pointBorderColor: 'transparent',
                    pointBackgroundColor: 'transparent',
                    pointHoverBackgroundColor: 'transparent',
                    lineTension: 0,
                    borderWidth: 1,
                    lineWidth: .5,
                    showLines: true,
                    backgroundColor: 'transparent'
                },
            ]
        }
        this.renderChart(chartData, this.options)
    },
    methods: {}
}



// WEBPACK FOOTER //
// ./src/pages/keyword/component__line_chartjs.js